import React from 'react';

export const BrandName: React.FC = () => {
	return <span className="brand-name">Readycheck</span>;
};
